import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { chatAppAccessGuard, chatAppGuestGuard, chatAppSessionGuard } from './core/chat-app.guards';
import { ChatAppHandoffComponent } from './pages/handoff/chat-app-handoff.component';
import { ChatAppSignInComponent } from './pages/sign-in/chat-app-sign-in.component';
import { ChatAppUnavailableComponent } from './pages/unavailable/chat-app-unavailable.component';
import { ChatAppConversationRouteComponent } from './routes/chat-app-conversation-route.component';
import { ChatAppDirectRouteComponent } from './routes/chat-app-direct-route.component';
import { ChatAppHomeComponent } from './routes/chat-app-home.component';
import { ChatAppShellComponent } from './shell/chat-app-shell.component';

/**
 * The chat app's URL contract (SPEC-2026-09-internal-chat-pwa, RF-02) — kept in step with
 * `chat-app-url.util.ts` in the shared library, which builds and validates these paths.
 */
const routes: Routes = [
  { path: 'login', component: ChatAppSignInComponent, canActivate: [chatAppGuestGuard] },
  { path: 'handoff', component: ChatAppHandoffComponent },
  { path: 'unavailable', component: ChatAppUnavailableComponent },
  {
    path: '',
    component: ChatAppShellComponent,
    canActivate: [chatAppSessionGuard, chatAppAccessGuard],
    children: [
      { path: '', pathMatch: 'full', component: ChatAppHomeComponent },
      { path: 'c/:channelId', component: ChatAppConversationRouteComponent },
      { path: 'c/:channelId/m/:messageId', component: ChatAppConversationRouteComponent },
      { path: 'c/:channelId/t/:threadRootId', component: ChatAppConversationRouteComponent },
      { path: 'dm/:userId', component: ChatAppDirectRouteComponent },
      { path: '', loadChildren: () => import('./panes/chat-app-panes.module').then((m) => m.ChatAppPanesModule) },
    ],
  },
  { path: '**', redirectTo: '' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { bindToComponentInputs: false, paramsInheritanceStrategy: 'emptyOnly' })],
  exports: [RouterModule],
})
export class ChatAppRoutingModule { }
